import React, { useEffect, useRef, useState } from "react";
import { convertNumberToWords } from "../../AdminBilling";
import { useSelector } from "react-redux";
import { ImagePath } from "../../../../../config/apiEndPoints";
import { getManagePolicyData } from "../../../../../redux/actions/dashBoardActions";
import { useDispatch } from "react-redux";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const PreviewInvoice = ({
  open,
  onClose, isloading,
  sunTotal,
  discount,
  discountPrice,
  totalPrice,
  customerSymbol,
  address,
  data,
  data1,
  setSubmitInvoice,
}) => {

  const [actionType, setactionType] = useState()
  const dispatch = useDispatch()
  const profileData = useSelector((state) => state.employeeData?.profile)
  const companyPolicy = useSelector((state) => state.commenData?.companyPolicy)

  useEffect(() => {
    dispatch(getManagePolicyData({companyId : profileData?.company?.id ,path:"policies"}))
  }, [])
  // //console.log("open profileData" ,companyPolicy);
  const printRef = useRef();

  const handleDownloadPdf = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgProps = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(data, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save('download.pdf');
  };


  return (
    <React.Fragment>
      <div className="modal fade show none" aria-modal="true" role="dialog" style={{ display: "block" }}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div  className="modal-content shadow p-4">
            <div ref={printRef} className=" border p-4 rounded invoice-box shadow-sm bg-white">
              <div className="d-flex justify-content-between align-items-start border-bottom pb-3">
                <div>
                  <img className="w-20 h-20 pb-1" src={profileData?.company?.company_logo ? ImagePath + profileData?.company?.company_logo
                    : "/assets/img/logoNew.png"} alt="logo" />
                  {/* <h4 className="brand text-danger">Smart<span className="fw-bold">HR</span></h4> */}
                  <p>
                    {profileData?.company?.company_address} ,{profileData?.company.state}({profileData?.company.pincode}),
                    {/* {profileData?.company.country} */}
                  </p>
                </div>
                <div className="text-end">
                  <h5 className="fw-bold">Invoice No <span className="text-primary">#{data1?.invoice}</span></h5>
                  <p>Created Date : {data1?.invoiceDate}<br />Due Date :{data1?.dueDate}</p>
                </div>
              </div>

              <div className="row border-bottom py-3">
                <div className="col-md-6">
                  <h6 className="fw-bold">From</h6>
                  <p className="mb-0 fw-bold">
                    {profileData?.company?.company_name}
                  </p>
                  <p>
                    {profileData?.company?.company_address},
                    {profileData?.company.city},
                    {profileData?.company.state}({profileData?.company.pincode}),
                    {profileData?.company.country}
                    <br />
                    {/* Email: Tarala2445@example.com<br />
                    Phone: +1 987 654 3210 */}
                  </p>
                </div>
                <div className="col-md-6 text-end">
                  <h6 className="fw-bold">To</h6>
                  <p className="mb-0 fw-bold">{address?.customerName}</p>
                  <p>{address.address},<br />
                    {address.city},
                    {address.state}({address.pincode}),
                    {address.country}<br />
                    {/* Email: Sara_inc34@example.com<br />
                    Phone: +1 987 471 6589 */}
                  </p>
                </div>
              </div>

              {/* <p className="fw-bold mt-4">Invoice For : <span className="fw-normal">Design & development of Website</span></p> */}

              <table className="table table-bordered mt-3">
                <thead className="bg-light">
                  <tr>
                    <th style={{ width: "50px" }}>#</th> {/* Reduced width for SN */}
                    <th>Item & Description</th>
                    <th style={{ width: "50px" }}>Qty</th> {/* Reduced width for Quantity */}
                    <th style={{ width: "150px" }}>Rate</th>
                    <th style={{ width: "150px" }}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((emp, index) => (
                    <tr key={index}>
                      <td >{index + 1}</td> {/* Reduced width for SN */}
                      <td>{emp?.item}</td>
                      <td >{emp?.quantity}</td> {/* Reduced width for Quantity */}
                      <td>{emp?.rate}</td>
                      <td>{emp?.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>


              <div className="row mt-4 border-bottom py-3">
                <div className="col-md-6">
                  {/* <h6 className="fw-bold">Terms and Conditions</h6>
                  <p>
                    Please pay within 15 days from the date of invoice, overdue interest @ 14% will be charged on delayed payments.
                  </p>
                  <h6 className="fw-bold">Notes</h6>
                  <p>Please quote invoice number when remitting funds.</p> */}
                </div>
                <div className="col-md-6">
                  <table className="table borderless">
                    <tbody>
                      <tr>
                        <td className="text-end">Sub Total</td>
                        <td className="text-end">{customerSymbol} {sunTotal}</td>
                      </tr>
                      <tr>
                        <td className="text-end">Discount({discountPrice > 0 ? discountPrice : `${discount}%`})</td>
                        <td className="text-end">
                          (-) {customerSymbol}{discountPrice > 0 ? discountPrice : (sunTotal * (discount || 0)) / 100}

                        </td>
                      </tr>
                      {/* <tr>
                        <td className="text-end">VAT(5%)</td>
                        <td className="text-end">$54</td>
                      </tr> */}
                      <tr className="fw-bold">
                        <td className="text-end">Total Amount</td>
                        <td className="text-end ">{customerSymbol} {totalPrice}</td>
                      </tr>
                    </tbody>
                  </table>
                  <p className="text-end"><strong>Amount in Words :</strong> {customerSymbol} {convertNumberToWords(parseInt(totalPrice))}</p>
                </div>
              </div>

              {/* { //console.log(parseInt(totalPrice))} */}


              <div className="row mt-5 align-items-center border-bottom pb-3">
                <div className="col-md-6"></div>
                <div className="col-md-6 text-end">
                  <div className="d-flex justify-content-end">
                    <img src={companyPolicy?.authorized_signature_url ? ImagePath+ companyPolicy?.authorized_signature_url : "/assets/img/sign.svg" }alt="Signature" height="50" />
                  </div>
                  <p className="mb-0 fw-bold">{companyPolicy?.authorized_person_name||"NA"}</p>
                  <p className="text-muted">{companyPolicy?.authorized_person_designation||"NA"}</p>
                </div>
              </div>


              <div className="text-center pt-3">
                <div className="d-flex pb-2 justify-content-center" >
                  <img className="w-20 h-20 pb-1" src={profileData?.company?.company_logo ? ImagePath + profileData?.company?.company_logo
                    : "/assets/img/logoNew.png"} alt="logo" />
                  {/* <img className="w-30 h-30" src="/assets/img/logoNew.png" alt="logo" /> */}
                </div>
                <div>
                  <p className="text-dark fs-14 m-0">Payment Made Via bank transfer / Cheque in the name of Thomas Lawler</p>
                  <div className="d-flex gap-2 py-1 justify-content-center">
                    <p className="text-dark m-0 fs-12">
                      <span className="text-gray ">Bank Name :</span>  {companyPolicy?.bank_name || "NA "}
                    </p>
                    <p className="text-dark m-0 fs-12">
                      <span className="text-gray ">Account Number : </span>   {companyPolicy?.bank_ac || "NA"}
                    </p>
                    <p className="text-dark m-0 fs-12">
                      <span className="text-gray ">IFSC :  </span>   {companyPolicy?.swift_code || "NA"}
                    </p>
                  </div>
                    <p className="text-dark text-end m-0 p-0">
                      <small>Powered By CV-Infotech.</small>
                    </p>
                </div>
                {/* <span className="ms-2 fs-5 fw-bold text-danger">Smart<span className="text-dark">HR</span></span> */}
              </div>

            </div>
            <div className="invoice-actions" style={{ marginTop: "20px" }}>
              <button
                className="cancel-btn"
                style={{
                  justifyContent: "flex-end",
                  alignSelf: "flex-end",
                  display: "flex",
                }}
                onClick={() => {
                  onClose();
                  // handleDownloadPdf()
                }}
              >
                Cancel
              </button>
              <button
                className="save-draft-btn"
                onClick={() => {
                  if (!isloading) {
                    setSubmitInvoice("Save As Draft");
                    setactionType("Save As Draft")
                  }
                  // onClose();
                }}
              >
                {
                  isloading && actionType == "Save As Draft" ? "Loading ..." : "Save As Draft"}
              </button>
              <button
                className="save-send-btn"
                onClick={() => {
                  if (!isloading) {
                    setSubmitInvoice("Save And Send");
                    setactionType("Save And Send")

                  }
                }}
              >
                {
                  isloading && actionType == "Save And Send" ? "Loading ..." : "Save And Send"
                }

              </button>
            </div>
          </div>
        </div>
      </div>

    </React.Fragment>
    // <Modal
    //   open={open}
    //   onClose={onClose}
    //   center
    //   showCloseIcon={false}
    //   closeOnOverlayClick={false}
    // >

    //   <AdminBilling
    //     subtotal={sunTotal}
    //     discount={discount}
    //     discountPrice={discountPrice}
    //     totalPrice={totalPrice}
    //     customerSymbol={customerSymbol}
    //     address={address}
    //     data={data}
    //     data1={data1}
    //   />

    //   <div className="invoice-actions" style={{ marginTop: "20px" }}>
    //     <button
    //       className="cancel-btn"
    //       style={{
    //         justifyContent: "flex-end",
    //         alignSelf: "flex-end",
    //         display: "flex",
    //       }}
    //       onClick={() => {
    //         onClose();
    //       }}
    //     >
    //       Cancel
    //     </button>
    //     <button
    //       className="save-draft-btn"
    //       onClick={() => {
    //         if (!isloading) {
    //           setSubmitInvoice("Save As Draft");
    //           setactionType("Save As Draft")
    //         }
    //         // onClose();
    //       }}
    //     >
    //       {
    //         isloading && actionType == "Save As Draft" ? "Loading ..." : "Save As Draft"}
    //     </button>
    //     <button
    //       className="save-send-btn"
    //       onClick={() => {
    //         if (!isloading) {
    //           setSubmitInvoice("Save And Send");
    //           setactionType("Save And Send")

    //         }
    //       }}
    //     >
    //       {
    //         isloading && actionType == "Save And Send" ? "Loading ..." : "Save And Send"
    //       }

    //     </button>
    //   </div>
    // </Modal>
  );
};

export default PreviewInvoice;
